import logger from './logger'

export { logger }

const loggingService = {
  logger
}

export default loggingService
